import { Button } from "@/components/ui/button";
import { Drawer, DrawerContent } from "@/components/ui/drawer";
import { User, Bell } from "lucide-react";

type SettingsMenuProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onNavigateToUserInfo: () => void;
  onNavigateToLineSettings: () => void;
};

export const SettingsMenu = ({
  open,
  onOpenChange,
  onNavigateToUserInfo,
  onNavigateToLineSettings
}: SettingsMenuProps) => {
  const handleMenuClick = (action: () => void) => {
    onOpenChange(false);
    action();
  };

  return (
    <Drawer open={open} onOpenChange={onOpenChange}>
      <DrawerContent className="bg-gray-50">
        <div className="mx-auto w-full max-w-md">
          <div className="flex justify-center p-4 pb-8">
            <div className="flex flex-col space-y-4">
              {/* ユーザー情報 */}
              <Button
                variant="ghost"
                className="flex h-auto items-center justify-start gap-3 p-4 hover:bg-gray-100"
                onClick={() => handleMenuClick(onNavigateToUserInfo)}
              >
                <User className="h-6 w-6 flex-shrink-0 text-gray-600" />
                <div className="text-lg font-medium">ユーザー情報</div>
              </Button>

              {/* スポット配信設定 */}
              <Button
                variant="ghost"
                className="flex h-auto items-center justify-start gap-3 p-4 hover:bg-gray-100"
                onClick={() => handleMenuClick(onNavigateToLineSettings)}
              >
                <Bell className="h-6 w-6 flex-shrink-0 text-orange-500" />
                <div className="text-lg font-medium">スポット配信設定</div>
              </Button>
            </div>
          </div>
        </div>
      </DrawerContent>
    </Drawer>
  );
};
